<template>
  <v-card>
    <v-card-text>
      <h3>Energy and Work</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'BTU',
          val: 1
        },
        {
          text: 'calorie (cal)',
          val: 251.9957963122
        },
        {
          text: 'electronvolt (eV)',
          val: 6.585142305005e21
        },
        {
          text: 'erg',
          val: 10550560000
        },
        {
          text: 'foot-pound',
          val: 778.1693709679
        },
        {
          text: 'gigajoule (GJ)',
          val: 0.000001055056
        },
        {
          text: 'joule (J)',
          val: 1055.056
        },
        {
          text: 'kilocalorie (kcal)',
          val: 0.2519957963122
        },
        {
          text: 'kilojoule (kJ)',
          val: 1.055056
        },
        {
          text: 'kilowatt hour (kWh)',
          val: 0.0002930711111111
        },
        {
          text: 'megajoule (MJ)',
          val: 0.001055056
        },
        {
          text: 'nutrition calorie (Cal)',
          val: 0.2519957963122
        },
        {
          text: 'ton of TNT (tn)',
          val: 2.521644359465e-7
        },
        {
          text: 'watt hour (Wh)',
          val: 0.2930711111111
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// energy.vue?624da5d9